
export default {
  name: 'ReviewsViewMapSectionSocialLinks',
  data() {
    return {
      socialIcons: {
        facebook: 'IconReviewFacebook-32x32',
        twitter: 'IconReviewTwitterX-32x32',
        instagram: 'IconReviewInstagram-32x32',
        youtube: 'IconReviewYoutube-32x32',
      },
    };
  },
  props: {
    socialLinks: {
      type: Array,
      required: true,
    },
  },
};
